// extracted by mini-css-extract-plugin
export default {"zoomModal":"j3-z","image":"k3-z","button":"l3-z","isOverlayShown":"m3-z"};